import * as ToastPrimitive from '@radix-ui/react-toast';
import { forwardRef } from 'react';
import { cn } from '@/utils/cn';

const ToastProvider = ToastPrimitive.Provider;
const ToastViewport = forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitive.Viewport
    ref={ref}
    className={cn(
      "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1000] flex flex-col items-center justify-center p-6",
      className
    )}
    {...props}
  />
));

const Toast = forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitive.Root
    ref={ref}
    className={cn(
      "px-4 py-3 bg-black/90 rounded-md inline-flex justify-center items-center gap-2.5 z-[1000] data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-top-full data-[state=open]:slide-in-from-top-full",
      className
    )}
    {...props}
  />
));

const ToastAction = forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitive.Action
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center rounded px-3 text-xs font-medium transition-colors",
      className
    )}
    {...props}
  />
));

const ToastClose = forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitive.Close
    ref={ref}
    className={cn(
      "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100",
      className
    )}
    toast-close=""
    {...props}
  />
));

const ToastTitle = forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitive.Title
    ref={ref}
    className={cn("text-center justify-start text-white text-sm font-normal", className)}
    {...props}
  />
));

const ToastDescription = forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitive.Description
    ref={ref}
    className={cn("text-center justify-start text-white text-sm font-normal", className)}
    {...props}
  />
));

export {
  ToastProvider,
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastAction,
}; 